// import React from "react";
// import { useTranslation } from "react-i18next";

// const SubCategory = ({ subcategories = [] }) => {
//   const { t, i18n } = useTranslation();
//   const currentLanguage = i18n.language || "en";

//   // Helper function to get localized text
//   const getLocalizedText = (item, field) => {
//     if (!item || !item[field]) return "";
    
//     if (typeof item[field] === 'string') {
//       return item[field];
//     }
    
//     if (typeof item[field] === 'object') {
//       return item[field][currentLanguage] || 
//              item[field].en || 
//              item[field].hi || 
//              item[field].es || 
//              item[field].zh || 
//              "";
//     }
    
//     return "";
//   };

//   return (
//     <div className="bg-white py-6 md:py-10 px-6 md:px-10">
//       <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-10 gap-2 items-center">
//         {subcategories.map((sub) => {
//           const subCategoryName = getLocalizedText(sub, "name");
//           return (
//             <div
//               key={sub._id}
//               className="flex flex-col items-center text-center"
//             >
//               {/* Circle Image Wrapper */}
//               <div className="w-24 h-24 rounded-full bg-gray-100 flex items-center justify-center overflow-hidden shadow-sm">
//                 <img
//                   src={sub.imgUrl}
//                   alt={subCategoryName}
//                   className="w-20 h-20 object-contain"
//                   onError={(e) => {
//                     e.target.src = "https://via.placeholder.com/100x100?text=No+Image";
//                   }}
//                 />
//               </div>

//               {/* Name */}
//               <h4 className="mt-3 text-sm font-semibold text-gray-800">
//                 {subCategoryName}
//               </h4>
//             </div>
//           );
//         })}
//       </div>
//     </div>
//   );
// };

// export default SubCategory;





import React from "react";
import { useTranslation } from "react-i18next";

const SubCategory = ({ subcategories = [], selectedSubCategory, onSelect }) => {
  const { i18n } = useTranslation();
  const currentLanguage = i18n.language || "en";

  const getLocalizedText = (item, field) => {
    if (!item?.[field]) return "";
    if (typeof item[field] === "string") return item[field];
    return item[field][currentLanguage] || item[field].en || item[field].hi || "";
  };

  return (
    <div className="bg-white py-6 md:py-8 px-6 md:px-10 border-b border-gray-100">
      <div className="flex flex-row flex-nowrap overflow-x-auto gap-4 pb-2 scrollbar-hide">
        {subcategories.map((sub) => {
          const name = getLocalizedText(sub, "name");
          const isActive = selectedSubCategory === sub._id;
          return (
            <div
              key={sub._id}
              onClick={() => onSelect?.(isActive ? null : sub._id)}
              className="flex flex-col items-center text-center flex-shrink-0 cursor-pointer group"
            >
              <div className={`w-20 h-20 rounded-full flex items-center justify-center overflow-hidden border-2 transition-all duration-200 ${isActive ? "border-orange-500 ring-2 ring-orange-200" : "border-gray-200 group-hover:border-orange-300"}`}>
                <img
                  src={sub.imgUrl}
                  alt={name}
                  className="w-full h-full object-cover"
                  onError={(e) => { e.target.src = "https://via.placeholder.com/100x100?text=?"; }}
                />
              </div>
              <h4 className={`mt-2 text-xs font-semibold w-20 line-clamp-2 leading-tight transition-colors ${isActive ? "text-orange-600" : "text-gray-700 group-hover:text-orange-500"}`}>
                {name}
              </h4>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default SubCategory;